import { createContext} from 'react';

const CommentContext = createContext();

export default CommentContext;